import { call, take, put }   from 'redux-saga/effects';
import axios                 from 'axios';
import { RECORD_ERROR_SAGA } from '../actions';
import setFatherApp          from 'functions/set_data/set_father_app';


const endpoint = 'https://www.yisumatica.org.il/yisumaticaApi/getFatherApp.php';

function* getFatherApp(): Generator<any,any,any> {
  while(true) {
    try {

        const input      = yield take('GET_FATHER_APP_SAGA');
        const selecedApp = input.payload;

        if (process.env.NODE_ENV === 'development') {

            console.log('selecedApp : ',selecedApp)
         //  setFatherApp(selecedApp)
 
        }
        if (process.env.NODE_ENV === 'production') {

            const res = yield call( axios.post, endpoint, { lessonId: selecedApp.father_app });

            if (res && res.data && res.data.result && res.data.result[0]) {

                console.log('res.data.result  : ',res.data.result)
                setFatherApp(res.data.result[0])
            }

            else {
              console.log("can't get father app")
            } 

            
        }
    }
    catch(err) {
      yield put(RECORD_ERROR_SAGA({ data: { error: err }, endpoint: 'GET_FATHER_APP_SAGA' }))
      console.log('err  :  '+err);
    }
    finally {}
  }
}


export default getFatherApp;






